import { render, staticRenderFns } from "./StockPrices.vue?vue&type=template&id=b82ef288&scoped=true&"
import script from "./StockPrices.vue?vue&type=script&lang=ts&"
export * from "./StockPrices.vue?vue&type=script&lang=ts&"
import style0 from "./StockPrices.vue?vue&type=style&index=0&id=b82ef288&prod&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b82ef288",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
